<template>
  <div>
    <v-card>
      <v-card-title class="custom-header">
        <v-icon left class="mr-2" color="#2c3e50">mdi-bank</v-icon>
        <span class="header-title">
          {{ formData.account_id == null ? "Nueva Cuenta" : "Editar Cuenta" }}
        </span>
        <span class="header-subtitle"
          >/
          {{
            type_accounts.find((x) => x.id == formData.account_type_id)?.description
          }}</span
        >
       
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid">
          <!-- Sección Generales -->
          <v-row class="mt-4">
            <v-col cols="4">
              <h5 class="section-title">Generales</h5>
              <p class="section-description">
                Información general de la cuenta, banco, tipo, moneda y número.
              </p>
            </v-col>
            <v-col cols="8">
              <v-row no-gutters>
                <v-col cols="12" sm="6">
                  <v-autocomplete
                    v-model="formData.account_bank_id"
                    :items="banks"
                    :readonly="formData.account_id != null"
                    label="Banco"
                    item-text="bank_description_long"
                    item-value="bank_id"
                    outlined
                    dense
                    required
                  ></v-autocomplete>
                </v-col>

                <v-col cols="8">
                  <v-autocomplete
                    v-model="formData.account_type_id"
                    :items="type_accounts"
                    label="Tipo cuenta"
                       :readonly="formData.account_id != null"
                    item-text="description"
                    item-value="id"
                    outlined
                    dense
                    required
                  ></v-autocomplete>
                </v-col>

                <v-col cols="4">
                  <v-autocomplete
                    v-model="formData.currency_id"
                    :items="currencies"
                    label="Moneda"
                       :readonly="formData.account_id != null"
                    item-text="code"
                    item-value="id"
                    class="mx-2"
                    outlined
                    dense
                    required
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="formData.account_check_digit"
                    label="Número cuenta"
                       :readonly="formData.account_id != null"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                  class="mx-2"
                    v-model="formData.account_name"
                    label="Nombre / name"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- Opciones de cuenta -->
          <v-divider class="mt-n6 mb-2"></v-divider>
          <v-row>
            <v-col cols="4">
              <h5 class="section-title">Opciones de cuenta</h5>
              <p class="section-description">
                Configura opciones adicionales de este tipo de cuenta.
              </p>
            </v-col>
            <v-col cols="8">
              <v-row>
                <v-col cols="6">
                  <v-checkbox
                    v-model="formData.hasChecks"
                    label="Cheques"
                    dense
                  ></v-checkbox>
                </v-col>
                <v-col cols="6">
                  <v-checkbox
                    v-model="formData.allowOverdraft"
                    label="Permitir sobregiro"
                    dense
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- Contabilidad -->
          <v-divider class="my-4"></v-divider>
          <v-row>
            <v-col cols="4">
              <h5 class="section-title">Contabilidad</h5>
              <p class="section-description">Determina la cuenta contable en el mayor.</p>
            </v-col>
            <v-col cols="8">
              <v-row>
                <v-col cols="3"> </v-col>

                <!-- Mostrar Autocomplete cuando se selecciona "Determinar cuenta" -->
                <v-col cols="8">
                  <v-autocomplete
                    v-model="formData.chart_of_account_id"
                    :items="accounts"
                    label="Cuenta No"
                    outlined
                    dense
                    required
                    :item-text="(item) => item.code + ' - ' + item.name"
                    item-value="id"
                    hide-no-data
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="data.item.code + ' - ' + data.item.name"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <h5 class="section-title">Email del representante</h5>
              <p class="section-description">
                Registra el email del representante de la cuenta.
              </p>
            </v-col>
            <v-col cols="8">
              <v-text-field
                v-model="formData.representative_email"
                label="Email representante"
                outlined
                dense
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- Balance inicial -->
          <!-- <v-divider class="my-4"></v-divider>
          <v-row>
            <v-col cols="4">
              <h5 class="section-title">Balance inicial</h5>
              <p class="section-description">
                Registra el balance inicial de la cuenta y el origen de los fondos.
              </p>
            </v-col>
            <v-col cols="8">
              <v-checkbox
                v-model="localFormData.hasInitialBalance"
                label="La cuenta posee balance inicial"
                dense
              ></v-checkbox>
            </v-col>
          </v-row> -->

          <!-- Opciones adicionales -->
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog">Cancelar</v-btn>
        <v-btn color="primary" @click="saveAccount">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    isEditing: {
      type: Boolean,
      default: false,
    },
    business_id: {
      type: Number,
    },
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      valid: false,
      aliasError: "Nombre / name: es un campo obligatorio!",
      localFormData: { ...this.formData }, // Copia de los datos de formData para editar
      banks: [],
      type_accounts: [],
      currencies: [],
      accounts: [],
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      const result = await Promise.all([
        this.g_Bancos(),
        this.g_type_account(),
        this.g_currencies(),
        this.api_Get("accounting/accountsUsable"),
      ]);
      this.banks = await result[0];
      this.type_accounts = await result[1];
      this.currencies = await result[2];
      this.accounts = await result[3].json();
    },
    closeDialog() {
      this.$emit("close", false);
    },
    async saveAccount() {
      if (this.formData.account_id != null) {
        let update_account = {
          account_id: this.formData.account_id,
          account_type_id: this.formData.account_type_id,
          account_name: this.formData.account_name,
          currency_id: this.formData.currency_id,
          account_check_digit: this.formData.account_check_digit,
          chart_of_account_id: this.formData.chart_of_account_id,
          representative_email: this.formData.representative_email,
        };
        const res2 = await this.api_Put("humanResource/accounts", update_account);
      } else {
        let data = {
          account_type_id: this.formData.account_type_id,
          bank_id: this.formData.account_bank_id,
          account_name: this.formData.account_name,
          check_digit: this.formData.account_check_digit,
        };
        const request = await this.api_Post("humanResource/new_accounts", data);
        let resultAccount = await request.json();
       
        let retorno = resultAccount[0].id;

        await this.joinAccountBussineUnit(
          retorno,
          this.formData.currency_id,
          this.business_id
        );
        let account = {
          account_id: retorno,
          account_type_id: this.formData.account_type_id,
          account_name: this.formData.account_name,
          currency_id: this.formData.currency_id,
          account_check_digit: this.formData.account_check_digit,
          chart_of_account_id: this.formData.chart_of_account_id,
          representative_email: this.formData.representative_email,
        };
        const response = this.api_Put("humanResource/accounts", account);

        const update = await response;
      }
      this.$emit("refresh");
    },
    async joinAccountBussineUnit(account_id_let) {
      let data = {
        account_id: account_id_let,
        currency_id: this.formData.currency_id,
        business_unit_id: this.business_id,
      };
   
      const request = await this.api_Post("humanResource/bussinessUnit/account", data);

      const datas = await request.json();

      return datas;
    },
  },
};
</script>

<style scoped>
.headline {
  font-size: 22px;
  font-weight: bold;
}

.custom-header {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 1px solid #e0e0e0;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.header-subtitle {
  font-size: 14px;
  color: #7f8c8d;
  margin-left: 8px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
}

.section-description {
  font-size: 12px;
  color: #7f8c8d;
}

.v-card {
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.v-card-actions {
  justify-content: flex-end;
  padding: 16px;
}
</style>
